import { render, staticRenderFns } from "./NewProjectProvider.vue?vue&type=template&id=931977fc&scoped=true"
import script from "./NewProjectProvider.vue?vue&type=script&lang=js"
export * from "./NewProjectProvider.vue?vue&type=script&lang=js"
import style0 from "./NewProjectProvider.vue?vue&type=style&index=0&id=931977fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "931977fc",
  null
  
)

export default component.exports